export default {
  locale: 'zh-cn',
  'input-amount': {
    千: '千',
    万: '万',
    十万: '十万',
    百万: '百万',
    千万: '千万',
    亿: '亿',
    十亿: '十亿',
    百亿: '百亿',
    千亿: '千亿',
    全部: '全部'
  },
  tips: {
    温馨提示: '温馨提示'
  },
  modal: {
    确定: '确定',
    取消: '取消'
  },
  scrollList: {
    加载中: '加载中...'
  },
  pullRefresh: {
    下拉刷新: '下拉刷新',
    释放立即刷新: '释放立即刷新',
    刷新中: '刷新中…'
  },
  result: {
    完成: '完成'
  },
  notice: {
    查看详情: '查看详情'
  },
  'datetime-picker': {
    完成: '完成',
    重置: '重置',
    确定: '确定',
    取消: '取消',
    年: '年',
    月: '月',
    日: '日',
    点: '点',
    分: '分',
    全部: '全部',
    近1月: '近1月',
    近半年: '近半年',
    近1年: '近1年',
    近2年: '近2年'
  },
  loading: {
    '加载中...': '加载中...'
  }
};